import {classes, style} from './thankyou-view.st.css';
import ThankYouViewIcon from './thankyou-view-icon.svg';
import React from 'react';
import {ButtonType, reactCreateMemo } from '@wix/devzai-utils-react';
import {
    DoppeActionTypeWidgetInnerButton,
} from '../../../components/doppe-action-type-widget-inner-button/doppe-action-type-widget-inner-button';
import {FlexLayout} from '@wix/devzai-common-client';
import {currencyFormatPrice, Price} from '@wix/devzai-utils-common';
import {
    DoppeHideableValue,
    doppeHideableValueGetValue,
    doppeHideableValueIsVisibleAndNotEqualValue,
} from '../../../client-server-common';
import {useDoppeViewerLocales} from '../../../client/doppe-viewer-locales/doppe-viewer-locales';
import {
    useDoppeViewerLang
} from "../../../components/doppe-viewer-bymo-page-props-react/doppe-viewer-bymo-page-props-react";

export const ThankYouView = reactCreateMemo(function ThankYouView(props: ThankYouView.Props) {
    const {
        onConfirm,
        price,
        name,
        customThankYouMessage,
    } = props;

    const lang = useDoppeViewerLang();
    const formattedAmount = currencyFormatPrice({
        price: price.amount,
        code: price.currencyCode,
        locale: lang,
    });

    const doppeViewerLocales = useDoppeViewerLocales();
    const thankYouTitle = doppeViewerLocales['thankyouModal.title']({ name });
    const thankYouText = doppeHideableValueIsVisibleAndNotEqualValue(customThankYouMessage, '')
        ? doppeHideableValueGetValue(customThankYouMessage)
        : doppeViewerLocales['thankyouModal.text']({ amount: formattedAmount });
    const thankyouButtonText = doppeViewerLocales['thankyouModal.button'];

    return (
        <div className={style(FlexLayout.column.default)}>
            <ThankYouViewIcon className={style(FlexLayout.alignSelf.center)} />
            <div className={style(classes.thankYouViewTitle, FlexLayout.alignSelf.center)}>{thankYouTitle}</div>
            <div className={style(classes.thankYouViewContent)}>{thankYouText}</div>
            <DoppeActionTypeWidgetInnerButton
                buttonType={ButtonType.NormalButton}
                onClick={onConfirm}
            >
                {thankyouButtonText}
            </DoppeActionTypeWidgetInnerButton>
        </div>
    );
});

export namespace ThankYouView {
    export interface Props {
        onConfirm: () => void;
        price: Price;
        name: string;
        customThankYouMessage: DoppeHideableValue<string>;
    }
}
